module.exports = __webpack_public_path__ + "static/img/extend2.d93ae88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new/extend2.png
// module id = JmYj
// module chunks = 0